<form [formGroup]="formFilter" cForm class="container-filter">

    <mat-form-field>
      <mat-label>Busqueda</mat-label>
      <input id="inputGeneral" matInput
        (keyup.enter)="filtroGeneral($event)"
        (input)="filtroGeneralTemporizado($event)"
        formControlName="generalFilter"
        placeholder="Busqueda "
      />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Estado</mat-label>
      <mat-select (selectionChange)="changeEstadoMinute($event)" formControlName="estado">      
        <mat-option value="1">Pendiente</mat-option>
        <mat-option value="2">Aprobada</mat-option>
        <mat-option value="3">Rechazada</mat-option>        
        <mat-option value="5">Eliminada</mat-option>
        <mat-option value="6">Anulada</mat-option>
        <mat-option value="7">Validas</mat-option>
        <mat-option value="8">Pre-Aprobadas</mat-option>
        <mat-option value="9">En Comité</mat-option>
        <mat-option value="0">Todas</mat-option>
      </mat-select>  
    </mat-form-field>
  
</form>